import React, { useEffect, useState } from "react";
import { ContractSideBar, Header } from "../../Elements";
import { assetsType, displayDateFormatShort, displayDateTimeFormatShort } from "../../../../constants";
import { sExportContractsAc } from "../../../../shared/actionCreators";
import { connect } from "react-redux";
import { ListLoader } from "../../../../shared";
import { Paper, Table, TableBody, TableCell, TableHead, TableRow, Button, Grid, TablePagination, Typography } from "@material-ui/core";
import { useSnackbar } from "notistack";
import { globalGetService, globalPostService } from "../../../../utils_v2/globalApiServices";
import { checkApiStatus } from "../../../../utils_v2";
import { STableLoader } from "../../../../shared_elements/loaders";
import { browserHistory } from "react-router";
import { Pagination } from "@material-ui/lab";
import { EmptyCollection, PageLoader } from "../../../../shared_elements";
import QuickBook from "./QuickBook";
import moment from "moment";

const QbProductService = ({ params, contractSummaryLoader }) => {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const [isLoading, setLoading] = useState(false);
  const [skeletonLoader, setSkeletonLoader] = useState(false);
  const [productServices, setproductServices] = useState({ list: [], pagination: null });
  const [filter, setFilter] = useState({});
  useEffect(() => {
    getProductAndServices({}, 'skeletonLoader');
  }, []);

  const getProductAndServices = (query = {}, loaderType) => {
    loaderType === 'skeletonLoader' ? setSkeletonLoader(true) : setLoading(true);
    globalGetService(`/contracts/product_and_services/`, query)
      .then(response => {
        if (checkApiStatus(response)) {
          setproductServices(response.data.data);
          setFilter(query)
        }
        loaderType === 'skeletonLoader' ? setSkeletonLoader(false) : setLoading(false);
      });
  };
  const getThirdPartyApp = (sync) => {
    localStorage.setItem('thirdPartyProductState', sync);
    setLoading(true)
    globalGetService(`contracts/app-plugin/quickbooks/authenticate/`)
      .then(response => {
        if (checkApiStatus(response)) {
          window.open(response.data?.data?.url, '_blank');
          setLoading(false)
        }
      })
      .catch(() => {
        enqueueSnackbar('Error syncing with QuickBooks', { variant: 'error', anchorOrigin: { horizontal: 'right', vertical: 'top' } });
      });
  };
  const getThirdParty = (data) => {
    getThirdPartyApp(data)
  };

  return (
    <div className="fleet-lease-management-sec" >
      {contractSummaryLoader ? <ListLoader /> : null}
      <QuickBook currentPath={window.location.href} />
      {skeletonLoader ? <STableLoader count={8} /> :
        <div>
          <Paper square style={{ padding: '4px 8px' }}>
            <Grid container spacing={1} alignItems="center">
              <Grid item md={9}>
                <Typography variant="subtitle1" style={{ fontWeight: 'bold', color: '#9439e4' }}> Last Synced by:{" "} <span style={{ fontSize: '12px', fontWeight: 'normal' }}> {productServices?.list?.[0]?.qb_last_sync_by?.name ? `${productServices.list[0].qb_last_sync_by.name} (${productServices.list[0].qb_last_sync_time ? moment(productServices.list[0].qb_last_sync_time).format(displayDateFormatShort) : '--'})` : '--'} </span> </Typography>
              </Grid>
              <Grid item md={3}>
                <ul className="list-inline flex-centered" style={{ float: 'right' }}>
                  <li className="list-inline-item">
                    <Button variant="contained" size="small" onClick={() => getThirdParty('SyncProductService')} color="primary"> sync Product & Services</Button>
                  </li>
                </ul>
              </Grid>
            </Grid>
          </Paper>
          <Paper style={{ overflow: "auto", maxHeight: `${window.innerHeight - 210}px` }}>
            <Table className="mui-table-format" stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell>Name</TableCell>
                  <TableCell>Sku</TableCell>
                  <TableCell>Type</TableCell>
                  <TableCell>Sales Description</TableCell>
                  <TableCell>Company Name</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {productServices.list.map((item, index) =>
                  <TableRow>
                    <TableCell>
                      <div style={{ width: '220px' }}>{item?.name || '--'}</div>
                    </TableCell>
                    <TableCell>
                      <div style={{ width: '220px' }}>{item?.sku || '--'}</div>
                    </TableCell>
                    <TableCell>
                      <div style={{ width: '220px' }}>{item?.type || '--'}</div>
                    </TableCell>
                    <TableCell>
                      <div style={{ width: '220px' }}>{item?.description || '--'}</div>
                    </TableCell>
                    <TableCell>
                      <div style={{ width: '220px' }}>{item?.company_name || '--'}</div>
                    </TableCell>
                  </TableRow>)}
              </TableBody>
            </Table>
          </Paper>
          {productServices.list?.length ?
            <Paper>
              <TablePagination
                rowsPerPageOptions={[10, 20, 50, 100, 200, 300, 400, 500]}
                component="div"
                count={productServices?.pagination?.total}
                rowsPerPage={productServices?.pagination?.per_page}
                page={productServices.pagination?.page - 1}
                backIconButtonProps={{ 'aria-label': 'previous page' }}
                nextIconButtonProps={{ 'aria-label': 'next page' }}
                onChangePage={(event, newPage) => getProductAndServices({ ...filter, page: newPage + 1, per_page: productServices.pagination.per_page }, 'pageLoader')}
                onChangeRowsPerPage={(event) => getProductAndServices({ ...filter, page: 1, per_page: event.target.value }, 'pageLoader')}
              />
            </Paper> : null}
        </div>}
      <Paper>
        {!productServices.list?.length && !skeletonLoader ? <div style={{ textAlign: 'center' }}><EmptyCollection title='No records found' /></div> : null}
      </Paper>
      {isLoading ? <PageLoader /> : null}
    </div>
  );
};

const mapStateToProps = (state) => ({
  contractSummaryLoader: state.sharedReducers.contractSummaryLoader,
});

const mapDispatchToProps = (dispatch) => ({
  exportContract: (contract_slug) => dispatch(sExportContractsAc(contract_slug)),
});

export default connect(mapStateToProps, mapDispatchToProps)(QbProductService);
